import React from "react";
import { useTranslation } from "react-i18next";
import servicesData from "../data/servicesData";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
export default function ServicesSection() {
    const { t } = useTranslation();
    UseScrollAnimation();

    const showData = servicesData.map((el, index) => (
        <div key={index} className="js-scroll fade-top w-100 flex flex-col gap-[15px] w-[31%]">
            <div>
                <img src={el.icons} alt="" />
            </div>
            <div>
                <div className="text-white font-bold text-[20px]">{t(`${el.title}`)}</div>
                <p className="text-[#989898] text-[15px]">{t(`${el.details}`)}</p>
            </div>
        </div>
    ))

    return (
        <section className="relative py-[40px]">
            <div className="flex flex-col py-[20px] mx-auto w-fit">
                <div className="js-scroll fade-top flex items-center gap-[5px] capitalize">
                    <span className="h-[2px] w-[25px] bg-[#A0642E]"></span>
                    <div className="font-bold text-white">{t("services")}</div>
                </div>
                <div className="js-scroll fade-btm font-bold text-white text-[35px]">{t("What I Offer")}</div>
            </div>
            <img className="d-none w-[200px] h-[200px] absolute bottom-0 left-[-45px]" src={require("../../assets/icons/serv-2.svg").default} alt="" />
            <img className="d-none absolute right-0 w-[100px] h-[100px]" src={require("../../assets/icons/serv-1.svg").default} alt="" />
            <div className="container flex flex-wrap gap-[20px] justify-between items-center">
                {showData}
            </div>
        </section>
    );
}